export default function FormIcon({ className }: any) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 8H20V17C20 17.9428 20 18.4142 19.7071 18.7071C19.4142 19 18.9428 19 18 19H14V8Z"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M2 8H8V19H4C3.05719 19 2.58579 19 2.29289 18.7071C2 18.4142 2 17.9428 2 17V8Z"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <rect x="8" y="8" width="6" height="11" stroke="currentColor" strokeLinecap="round" />
      <path
        d="M2 5C2 4.05719 2 3.58579 2.29289 3.29289C2.58579 3 3.05719 3 4 3H18C18.9428 3 19.4142 3 19.7071 3.29289C20 3.58579 20 4.05719 20 5V8H2V5Z"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
}
